import { Injectable, } from '@angular/core';
import { Http, Headers, URLSearchParams, Response, HttpModule, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  base_url: string;
  constructor(
    private http: HttpClient,
  ) {
    this.base_url = environment.appUrl;
  }


  makeLogin(userDetails): Observable<any> {
    let headers = new Headers();
    JSON.stringify(userDetails);
    headers.append('Content-Type', 'application/json');
    return this.http.post(this.base_url + '/login', JSON.stringify(userDetails));
  }

  newRegistration(registerData): Observable<any> {
    return this.http.post(this.base_url + '/registration', JSON.stringify(registerData));
  }

  getAllUsers(): Observable<any> {
    return this.http.get(this.base_url + '/tenantusers');
  }
  getTenantUsers(userName): Observable<any> {
    return this.http.get(this.base_url + '/tenantusers/' + userName);
  }

  getUserById(id): Observable<any> {
    return this.http.get(this.base_url + '/tenantusers/id/' + id.user);
  }

  addUser(userData): Observable<any> {
    return this.http.post(this.base_url + '/tenantusers/registration', userData);
  }

  addUserResurce(userData): Observable<any> {
    return this.http.post(this.base_url + '/tenantusers/userregistration', userData);
  }

  activateUser(userid, bActivate): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.patch(this.base_url + '/tenantusers/id/' + userid, bActivate, httpOptions);
  }


  getRolesByUsers(): Observable<any> {
    let username = sessionStorage.getItem('userdetails')
    return this.http.get(this.base_url + '/tenantusers' + "/" + username + "/roles");
  }

  updateUser(user: any): Observable<any> {
    return this.http.put(this.base_url + '/tenantusers', user);
  }

  logoutUser(token): Observable<any> {
    return this.http.post(this.base_url + '/logout', token);
  }

  getAllUserActivity(fromDate: string, toDate: string): Observable<any> {
    return this.http.get(this.base_url + '/tenantusers/activity?fromDate=' + fromDate + '&toDate=' + toDate);

  }

  getUserReport(onDate: string): Observable<any> {
    return this.http.get(this.base_url + '/reports/usersummary?onDate=' + onDate);
  }

  getOnOffDutyUserData(fromDate: string, toDate: string): Observable<any> {
    return this.http.get(this.base_url + '/reports/onoffduty?fromDate=' + fromDate + '&toDate=' + toDate);
  }

  getAllRoles(): Observable<any> {
    return this.http.get(this.base_url + "/tenantusers/getallroles");
  }

  updateUserAndResource(user: any): Observable<any> {
    return this.http.put(this.base_url + '/users/updateuser', user);
  }
}
